export const getUrlParam = (param, defaultValue = "") => {
  const params = new URLSearchParams(window.location.search);
  return params.get(param) || defaultValue;
};

export const setUrlParams = (params, replace = true) => {
  const searchParams = new URLSearchParams(window.location.search);

  Object.entries(params).forEach(([key, value]) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      searchParams.delete(key);
      return;
    }
    searchParams.set(key, value);
  });

  const newUrl = `${
    window.location.pathname
  }?${searchParams.toString()}`;

  if (replace) {
    window.history.replaceState({}, "", newUrl);
  } else {
    window.history.pushState({}, "", newUrl);
  }
};

export const getOnboardingParams = () => {
  const params = new URLSearchParams(window.location.search);

  // Convert string to number if it's a valid number
  const sr = params.get("selectedRole");
  const selectedRole = sr && /^\d+$/.test(sr) ? Number(sr) : sr || "";

  return {
    selectedRole,
    templateType: params.get("templateType") || "",
    referralSource: params.get("referralSource") || "",
    clinicGroup: params.get("clinicGroup") || "",
    from: params.get("from") || "",
  };
};
